module.exports = __webpack_public_path__ + "static/img/implementService.16e5c6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/implementService.jpg
// module id = tJzb
// module chunks = 1